module.exports = __webpack_public_path__ + "img/kebijakan-semua.387cc8f1.svg";